import { render } from "./AddVatTuTableItems.vue?vue&type=template&id=ba9c05e2&ts=true"
import script from "./AddVatTuTableItems.vue?vue&type=script&lang=ts"
export * from "./AddVatTuTableItems.vue?vue&type=script&lang=ts"

import "./AddVatTuTableItems.vue?vue&type=style&index=0&id=ba9c05e2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__